;(function module() {
  angular.module('app.ui.form.ctrls').controller('HelpModalController', [
    '$uibModalInstance',
    'helpModal',
    function controller($uibModalInstance, helpModal) {
      var vm = this
      vm.helpModal = helpModal
      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/ag-grid-listing/help-modal/help-modal.ctrl.js